/* 国际化en_US */

module.exports = {
  common: {
    password: "Password",
    acre: "ha",
    spaceAcre: "ha",
    emailLabel: "Email",
    rightEmail: "Please enter correct email",
    emailInfoTxt: "Please enter your email",
    submitTxt: "Confirm",
    passwordInfoTxt: "Please enter your password",
    wrongPasswordTxt: "Password should contain 6 to 15 digits or letters",
    footerText: "Record farm updates anytime and anywhere and share the updates with others",
    bottomText: "Manage current important tasks and work with other members of the farm efficiently",
    pullingText: "Pull down to refresh...",
    loosingText: "Release can refresh...",
    loadingText: "Loading...",
    exceptionText: "Load exception, please try again later",
    apiErrorText: "Interface error"
  },
  outsideInvite: {
    headerText: "Invite to join the farm",
    textTitle: "Invite you to join",
    invitation: "Accept the invitation"
  },
  outsideInviteDown: {
    textTitle: "Congratulations,you've joined successfully",
    download: "Download App"
  },
  outsideInviteLogin: {
    login: "Log in",
    forgetPassword: "Forgot password?",
    remindInfo: "Have no account yet?",
    resigsterInfo: "Register now",
    welcomeTxt: "Welcome to World Farm"
  },
  outsideInviteRegister: {
    createAccount: "Create an account",
    userName: "Name",
    userNameInfo: "Please enter your name",
    agreementInfo: "Please agree with Conditions of Use",
    confirmInfo: "I confirm and agree with the",
    userProtol: "Conditions of Use",
    registerInfo: "Register"
  },
  outsidePasswordEmail: {
    label: "Email",
    findPassword: "Retrieve password",
    desc: "We will send a password resetting email to your email address.",
    infoTxt: "Please enter your email",
    errorTxt: "Incorrect email format. Please enter it again.",
    verifyTxt: "Verification email has been sent. Please check your email."
  },
  outsidePasswordReset: {
    passwordLabel: "New password",
    passwordInfoTxt: "Please enter the new password",
    cofirmInfoTxt: "Confirm password",
    cofirmNewInfoTxt: "Please confirm the new password",
    wrongPasswordTxt: "The code you enter twice must be the same.",
    resetPasswordTxt: "Reset password successful"
  },
  outsidePasswordVerify: {
    headerText: "Email verification",
    tipsMsg: "Authenticating",
    successTipMsg: "Email verification successful"
  },
  outsideMap: {
    farmText: "Farm",
    HDMsg: "HD",
    lengthMsg: "Length",
    notesMsg: "Notes",
    temMsg: "temperature",
    humMsg: "Humidity",
    pensLengthMsg: "Length of penned zone(km)",
    pensAreaMsg: "Area of penned zone(ha)"
  },
  appStatistics: {
    noFarm: "No farm yet",
    CattlesTit: "Cattles",
    AbnormalTit: "Abnormal",
    Abnormal: "Abnormal cattles",
    ExtraneousTit: "Extraneous cattles",
    noLivestockData: "No livestock has been added yet.",
    handleAbnormalMsg: "View cattles which out of farms",
    handleExtraneousTit: "View extraneous cattles",
    openQuickSearch: "Enabled"
  },
  appArticle: {
    registerText: "Conditions of Use",
    aboutUsText: "About Us",
    uploadText: "Upload"
  },
  appLivestockList: {
    reasonText: "Reason: not in LoRa network coverage",
    findCowTit: "Quick-search",
    daysMsg: "days",
    monthsMsg: "months"
  }
};
